module.exports = __webpack_public_path__ + "static/media/kyle.c417878d.jpeg";